// extracted by mini-css-extract-plugin
export var button = "_fz-4";
export var hasDarkBackground = "_fz-7";
export var hasLightBackground = "_fz-6";
export var iconWrapper = "_fz-0";
export var large = "_fz-2";
export var medium = "_fz-1";
export var small = "_fz-5";
export var xsmall = "_fz-3";